import React from "react";
import { Empty, Button } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { hasPermission, privilegesEnum } from "../../helpers/PermissionHelper";
import styles from "./EmptyState.module.scss";

interface EmptyStateProps {
  type: "noData" | "noResults";
  entityName: string;
  createPath?: string;
  createPermission?: privilegesEnum;
  onClearFilters?: () => void;
  showClearButton?: boolean;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  type,
  entityName,
  createPath,
  createPermission,
  onClearFilters,
  showClearButton = false,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const getEmptyState = () => {
    if (type === "noResults") {
      return (
        <div className={styles.emptyState}>
          <Empty
            description={
              <div>
                <div className={styles.emptyTitle}>
                  {t(`${entityName}-EmptyFilterTitle`)}
                </div>
                <div className={styles.emptyDescription}>
                  {t(`${entityName}-EmptyFilterDescription`)}
                </div>
              </div>
            }
          />
        </div>
      );
    }

    if (type === "noData") {
      return (
        <div className={styles.emptyState}>
          <Empty
            description={
              <div>
                <div className={styles.emptyTitle}>
                  {t(`${entityName}-EmptyTitle`)}
                </div>
                <div className={styles.emptyDescription}>
                  {t(`${entityName}-EmptyDescription`)}
                </div>
              </div>
            }
          >
            {createPath && createPermission && hasPermission(createPermission) && (
              <Button
                type="primary"
                onClick={() => navigate(createPath)}
                className={styles.emptyButton}
              >
                {t(`${entityName}-EmptyButton`)}
              </Button>
            )}
          </Empty>
        </div>
      );
    }

    return null;
  };

  return getEmptyState();
};

export default EmptyState;
